var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"base-title"}},[_c('div',{staticClass:"title-border"}),_c('div',{staticClass:"page-title-wrapper"},[_c('div',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.pageTitle))]),_c('div',{staticClass:"page-subtitle"},[_vm._v(_vm._s(_vm.pageSubtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }